import React from 'react';

const GalleryItem = ({ image, title }) => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
      <div className="gallery-item mb-4 rounded overflow-hidden">
        <div className="gallery-image">
          <img src={image} alt={title} />
        </div>
        <div className="gallery-content">
          <h5 className="white text-center position-absolute bottom-0 pb-4 left-50 mb-0 w-100">
            {title}
          </h5>
          <ul>
            <li><a href={image} data-lightbox="gallery" data-title="Title"><i className="fa fa-eye"></i></a></li>
            <li><a href="#"><i className="fa fa-link"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const Gallery = () => {
  const galleryItems = [
    { image: '/images/gallery/086.jpeg', },
    { image: '/images/gallery/01.jpg', },
    { image: '/images/gallery/02.jpg', },
    { image: '/images/gallery/03.jpg', },
    { image: '/images/gallery/04.jpg', },
    { image: '/images/gallery/05.jpg', },
    { image: '/images/gallery/06.jpg', },
    { image: '/images/gallery/07.jpg', },
    { image: '/images/gallery/08.jpg', },
    { image: '/images/gallery/089.jpeg', },
    { image: '/images/gallery/090.jpeg', },
    { image: '/images/gallery/092.jpeg', },
    { image: '/images/gallery/09.jpg', },
    { image: '/images/gallery/010.jpg', },
    { image: '/images/gallery/011.jpg', },
    { image: '/images/gallery/012.jpg', },
    { image: '/images/gallery/013.jpg', },
    { image: '/images/gallery/014.jpg', },
    { image: '/images/gallery/015.jpg', },
    { image: '/images/gallery/016.jpg', },
    { image: '/images/gallery/017.jpg', },
    { image: '/images/gallery/018.jpg', },
    { image: '/images/gallery/019.jpg', },
    { image: '/images/gallery/020.jpg', },
    { image: '/images/gallery/021.jpg', },
    { image: '/images/gallery/022.jpg', },
    { image: '/images/gallery/023.jpg', },
    { image: '/images/gallery/024.jpg' },
{ image: '/images/gallery/025.jpg' },
{ image: '/images/gallery/026.jpg' },
{ image: '/images/gallery/027.jpg' },
{ image: '/images/gallery/028.jpg' },
{ image: '/images/gallery/029.jpg' },
{ image: '/images/gallery/030.jpg' },
{ image: '/images/gallery/031.jpg' },
{ image: '/images/gallery/032.jpg' },
{ image: '/images/gallery/033.jpg' },
{ image: '/images/gallery/034.jpg' },
{ image: '/images/gallery/035.jpg' },
{ image: '/images/gallery/036.jpg' },
{ image: '/images/gallery/037.jpg' },
{ image: '/images/gallery/038.jpg' },
{ image: '/images/gallery/039.jpg' },
{ image: '/images/gallery/040.jpg' },
{ image: '/images/gallery/041.jpg' },
{ image: '/images/gallery/042.jpg' },
{ image: '/images/gallery/043.jpg' },
{ image: '/images/gallery/044.jpg' },
{ image: '/images/gallery/045.jpg' },
{ image: '/images/gallery/046.jpg' },
{ image: '/images/gallery/047.jpg' },
{ image: '/images/gallery/048.jpg' },
{ image: '/images/gallery/049.jpg' },
{ image: '/images/gallery/050.jpg' },
{ image: '/images/gallery/051.jpg' },
{ image: '/images/gallery/052.jpg' },
{ image: '/images/gallery/053.jpg' },
{ image: '/images/gallery/054.jpg' },
{ image: '/images/gallery/055.jpg' },
{ image: '/images/gallery/056.jpg' },
{ image: '/images/gallery/057.jpg' },
{ image: '/images/gallery/058.jpg' },
{ image: '/images/gallery/059.jpg' },
{ image: '/images/gallery/060.jpg' },
{ image: '/images/gallery/061.jpg' },
{ image: '/images/gallery/062.jpg' },
{ image: '/images/gallery/063.jpg' },
{ image: '/images/gallery/064.jpg' },
{ image: '/images/gallery/065.jpg' },
{ image: '/images/gallery/066.jpg' },
{ image: '/images/gallery/067.jpg' },
{ image: '/images/gallery/068.jpg' },
{ image: '/images/gallery/069.jpg' },
{ image: '/images/gallery/070.jpg' },
{ image: '/images/gallery/071.jpg' },
{ image: '/images/gallery/072.jpg' },
{ image: '/images/gallery/073.jpg' },
{ image: '/images/gallery/074.jpg' },
{ image: '/images/gallery/075.jpg' },
{ image: '/images/gallery/076.jpg' },
{ image: '/images/gallery/077.jpg' },
{ image: '/images/gallery/078.jpg' },
{ image: '/images/gallery/079.jpg' },
{ image: '/images/gallery/080.jpg' },
{ image: '/images/gallery/081.jpg' },
    { image: '/images/gallery/091.jpeg', },

  ];

  return (

<div>



<section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
      <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
      <div className="breadcrumb-outer">
        <div className="container">
          <div className="breadcrumb-content text-center">
            <h1 className="mb-3"> Gallery</h1>

          </div>
        </div>
      </div>
      <div className="dot-overlay"></div>
    </section>


    <div className="gallery pt-6 pb-0">
      <div className="container">
        <div className="section-title mb-6 text-center w-75 mx-auto">
          <h4 className="mb-1 theme1">Our Gallery</h4>
          <h2 className="mb-1">
            Some Beautiful <span className="theme">Snapshoots</span>
          </h2>
        </div>

        <div className="row">
          {galleryItems.map((item, index) => (
            <GalleryItem key={index} image={item.image} title={item.title} />
          ))}
        </div>
      </div>
    </div>


</div>  );
};

export default Gallery;
